<template>
  <div class="matrix-single-choice">
    <matrix-form :rows="issue.rows" :columns="issue.items" column-key="id" :show-col-text="false">
      <template v-slot:content="{ row }">
        <van-radio-group :value="row.value">
          <div v-for="(col, index) of issue.items" :key="col.id" class="mb-1 last:mb-0">
            <single-choice-item :value="row.value" :item="col" @click="onChangeValue(row, col)" />
          </div>
        </van-radio-group>
      </template>
    </matrix-form>
  </div>
</template>

<script>
import MatrixForm from '@/questions/components/MatrixForm'
import SingleChoiceItem from '@/questions/components/SingleChoiceItem'

export default {
  name: 'MatrixSingleChoice',
  components: { SingleChoiceItem, MatrixForm },
  changeExpr: 'isSelectAll',
  computed: {
    isSelectAll() {
      return this.issue.rows.reduce((prev, item) => {
        return prev + '-' + item.value
      }, '')
    }
  },
  methods: {
    changeValue(val, row) {
      row.value = val
    },
    onChangeValue(row, col) {
      if (row.value === col.id) {
        if (!this.question.required) {
          row.value = ''
        }
      } else {
        row.value = col.id
      }
    }
  }
}
</script>

<style scoped></style>
